import React from 'react';
import clsx from 'clsx';
import Depot from '../../_shared/depot';
import * as styles from '../shared/style.module.css';
import ButtonPrimitive from '../shared/ButtonPrimitive';
const LinkButtonWithoutRef = ({ text, buttonType = 'primary', size = 'medium', disabled = false, fullWidth = false, alignIcon, className, icon, target = '_self', ...commonProps }) => {
    // Styles
    const buttonClasses = clsx(className, styles.root, styles[buttonType], styles[size], {
        [styles.fullWidth]: fullWidth,
    });
    return Depot.createElement('a', {
        className: buttonClasses,
        ['aria-disabled']: disabled,
        target,
        ...commonProps,
    }, React.createElement(ButtonPrimitive, { alignIcon: alignIcon, icon: icon, fullWidth: fullWidth, size: size, text: text, buttonType: buttonType, disabled: disabled }));
};
const LinkButton = Depot.withRef(LinkButtonWithoutRef);
LinkButton.displayName = 'LinkButton';
export default LinkButton;
//# sourceMappingURL=index.js.map